import { createContext } from 'react';
import type { GeneralMetaData } from 'apps/shared/data-access/types/metadata/metadata.types';

const MetadataContext = createContext<GeneralMetaData | null>(null);

export default MetadataContext;
